"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.revalidateExternalAuthorization = exports.performAction = exports.reviseAction = exports.useGetAdminUserRecord = exports.getAdminUser = exports.getAdminUserCallable = exports.assignRoleToSelf = void 0;
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const functions_1 = require("firebase/functions");
const react_1 = require("react");
const functions = (0, functions_1.getFunctions)(firebase_app_1.default, "asia-northeast1");
if (typeof localStorage !== "undefined" &&
    localStorage.getItem("useEmulator")) {
    (0, functions_1.connectFunctionsEmulator)(functions, "127.0.0.1", 5001);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.functions = functions;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.httpsCallable = functions_1.httpsCallable;
}
exports.assignRoleToSelf = (0, functions_1.httpsCallable)(functions, "assignRoleToSelf");
exports.getAdminUserCallable = (0, functions_1.httpsCallable)(functions, "getAdminUser");
const getAdminUser = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, exports.getAdminUserCallable)(params);
    return response.data;
});
exports.getAdminUser = getAdminUser;
const useGetAdminUserRecord = (params) => {
    const [response, setResponse] = (0, react_1.useState)(undefined);
    (0, react_1.useMemo)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!params) {
            setResponse(undefined);
        }
        else {
            const response = yield (0, exports.getAdminUserCallable)(params);
            setResponse(response.data);
        }
    }), [JSON.stringify(params)]);
    return [response === null || response === void 0 ? void 0 : response.user, !response];
};
exports.useGetAdminUserRecord = useGetAdminUserRecord;
const reviseActionCallable = (0, functions_1.httpsCallable)(functions, "reviseAction");
const reviseAction = (params) => __awaiter(void 0, void 0, void 0, function* () {
    yield reviseActionCallable(params);
});
exports.reviseAction = reviseAction;
const performActionCallable = (0, functions_1.httpsCallable)(functions, "performAction");
const performAction = (params) => __awaiter(void 0, void 0, void 0, function* () {
    yield performActionCallable(params);
});
exports.performAction = performAction;
exports.revalidateExternalAuthorization = (0, functions_1.httpsCallable)(functions, "revalidateExternalAuthorization");
